<template >
  <div>
    <div class="ml-30 pt-30 headlineContainer">
      <md-dialog-title v-if="id == null">{{options.Lang.neueCollection}}</md-dialog-title>
      <md-dialog-title v-if="id != null">{{options.Lang.editCollection}}</md-dialog-title>
      <md-button tabindex="7" class="md-raised secondary button-save"
        @click="close()"><strong>{{options.Lang.Fenster_schließen}}</strong>
      </md-button>
    </div>
    <br>

    <div class="groupMainContainer">

      <!-- ANGEBOTSGRUPPEN NAME -->
      <div class="groupNameContainer">
        <div class="groupName">
          <md-field class="md-focused inputContainer">
            <label for="bezeichnung"><strong>{{ options.Lang.Bezeichnung }}</strong></label>
            <md-input tabindex="4" name="bezeichnung" :placeholder="address.bezeichnung" @input="checksaveButton" id="bezeichnung"
              v-model="bezeichnung"/>
              <span id="snackBar2" class="dNone">{{ options.Lang.BezeichnungVergeben }}</span>
              <span id="succsesSave" class="dNone">{{ options.Lang.SuccessSave }}!</span>
          </md-field>
        </div>

        <div class="buttonContainer">
          <md-field>
            <md-button tabindex="7" disabled id="saveButton" class="md-raised md-primary button-save"  @click="save">
              <strong>{{options.Lang.Speichern}}</strong>
            </md-button>
          </md-field>
        </div>
      </div>


      <!-- TRIP HINZUFÜGEN -->
      <div class="groupTrip">
        <div class="addTrip">
          <div class="addTripContainer">
            <md-field class="md-focused">
              <label><strong>{{ options.Lang.addCollectionsTrip }}</strong></label>
              <md-autocomplete

              :value="form.supplier"
              :md-options="supplierList"
              @md-changed="getSupplierSelection"
              @md-selected="setSupplier"
              @md-opened="getSupplierSelection"
              :disabled="isAutocompleteDisabled"
              >
                <template slot="md-autocomplete-item" slot-scope="{ item }" id="autocompl">

                  <span class="showInfo mWidth7">{{ item.trip_id }}</span>
                  <span class="showInfo mWidth10">
                    {{ item.firstname + " " + item.lastname}}
                  </span>
                </template>
              </md-autocomplete>
            <span id="tripSnackbar" class="dNone">{{ options.Lang.TripNotFound }}</span>
            <span id="tripSnackbar2" class="dNone">{{ options.Lang.TripExist }}</span>
          </md-field>
          </div>
        </div>

        <div class="addTripDescription">
          <div class="addTripDescriptionContainer">
            <md-field class="md-focused">
              <label for="bezeichnungTrip"><strong>{{ options.Lang.BezeichnungTrip }}</strong></label>
              <md-input
              tabindex="4"
              name="bezeichnungTrip"
              :placeholder="address.bezeichnungTrip"
              id="bezeichnungTrip"
              v-model="bezeichnungTrip"
              @input="checkButton"
              :disabled="isAutocompleteDisabled2"
              />
            </md-field>
          </div>

          <div class="buttonContainer">
            <md-field>
              <md-button tabindex="7" id="addTripButton" class="md-raised md-primary button-save" @click="addTrip">
                <strong>{{ options.Lang.addCollectionsTrip }}</strong>
              </md-button>
            </md-field>
          </div>
        </div>
      </div>

      <!-- ANZEIGE TRIPS -->
      <div class="showTrips">
        <label><strong>{{ options.Lang.myCollections }}</strong></label>
        <br>
        <br>
        <label v-if="newCollections.length <= 0">{{ options.Lang.noCollectionTrips }}</label>
        <md-field v-if="renderComp" v-for="(brand, index) in newCollections" :key="index" class="modul">
          <p>
            <span>
              <md-icon>trip_origin</md-icon>
            </span>
            <span>
              <span class="tripBranding" v-if="brand?.brandingName">{{ brand.brandingName }}</span>
              <span class="tripBranding" v-if="!brand?.brandingName"></span>
              <span class="tripID">{{ brand.trip_id }}</span>
              <span class="tripBuyer">{{ brand.pax }}</span>
              <span class="tripDescription">
                <md-button @click="editTripFromCollection(brand)" v-if="!brand.editTrip"><md-icon>edit</md-icon></md-button>
                <md-button @click="saveEditedTrip(brand)" v-if="brand.editTrip"><md-icon>done_all</md-icon></md-button>
                <span v-if="!brand.editTrip">{{ brand.bezeichnungTrip }}</span>
                <div id="editWarn" class="dNone">{{ options.Lang.NeedDescription }}</div>
                <div>
                  <input class="editTripDesInput" type="text" v-if="brand.editTrip" v-model="brand.bezeichnungTrip">
                </div>
              </span>
            </span>
          </p>
          <div class="iconHandler showTripIcon">
            <md-button @click="triggerDeleteTripInfo(brand)"><md-icon class="icon">delete</md-icon></md-button>
          </div>
        </md-field>
      </div>


    </div>

    <Success class="errorDialog" v-if="options.showSuccess && options.user.loggedIn" :options="options"></Success>

          <div id="popUp" class="popUp dNone">
            <div class="popUpContainer">
              <div class="contentEdit2 md-elevation-10 pop">
                <div class="md-layout-item">
                  <p>{{ options.Lang.DeleteTrip }}</p>
                    <div class="buttonContainer">
                      <md-button class="secondary md-raised" @click="triggerDeleteTripInfo"><strong>Fenster schließen</strong></md-button>
                      <md-button class="md-primary md-raised" @click="deleteTripFromCollection()"><strong>löschen</strong></md-button>
                    </div>
                </div>
              </div>
            </div>
          </div>

  </div>

</template>

<script>

import * as moment from 'moment'
import { validationMixin } from 'vuelidate'
import Success from '../../components/dialogs/Success.vue'


export default {
  name: 'formGlobalInfo',
  mixins: [validationMixin],
  components: {
    Success
  },
  props: {
    options: {
      type: Object,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    bezeichnung:{
      required: true
    },
    collection:{
      required: true
    }
  },
  data: () => ({
    isAutocompleteDisabled: true,
    isAutocompleteDisabled2: true,
    remove: false,
    renderComp: false,
    brands: [],
    brandings: [],
    supplierList: [],
    suppliers: [],
    noGroupSuppliers: [],
    newCollections :[],
    bezeichnungTrip: null,
    address:{
      bezeichnung: null,
      bezeichnungTrip: null
    },
    form:{
      supplier: null
    },
    inputTripId: null,
    editTrip: false,
    deleteBrand: null
  }),
  created() {

  },
  async mounted() {

    if(this.id != null && this.id != ""){
      this.isAutocompleteDisabled = false
      this.isAutocompleteDisabled2 = false
    }

    await this.getAllBrandings()
    await this.getAllSuppliers()
    await this.getTrips()
    await this.getAllCollections()


    this.renderComp = true;
  },

  watch: {
    clear() {
    }
  },

  methods: {
    async getTrips() {
      // Ensure newCollections is always an array
      if (!this.newCollections || !Array.isArray(this.newCollections)) {
        this.newCollections = [];
      }
      this.newCollections = this.newCollections.filter(
          (item, index, self) =>
              item && item.id != null &&
              index === self.findIndex(t => t.id === item.id)
      );
      if (this.id == null) {
        this.bezeichnung = "";
      }

      if (this.collection != null && this.collection != "null" && this.collection != "") {
        let numArray;
        if (this.remove) {
          if (typeof this.collection === 'string') {
            try {
              numArray = JSON.parse(this.collection);
            } catch (e) {
              console.error('The collection is not a valid JSON string:', e);
            }
          } else {
            numArray = this.collection;
          }
        } else {
          if (typeof this.collection === 'string') {
            try {
              numArray = JSON.parse(this.collection);
            } catch (e) {
              console.error('The collection is not a valid JSON string:', e);
            }
          } else {
            numArray = this.collection;
          }
        }

        this.remove = false;

        // Ensure `newCollections` is an array before using `forEach`
        this.newCollections = Array.isArray(this.newCollections) ? this.newCollections : [];
        if (this.suppliers.length > 0) {
          this.suppliers.forEach(sup => {
            for (let i = 0; i < numArray.length; i++) {
              if (sup.trip_id === numArray[i].id) {
                let object = {
                  trip_id: sup.trip_id,
                  brandingID: sup.branding_id,
                  bezeichnungTrip: numArray[i]?.bezeichnung ? numArray[i].bezeichnung : "",
                  pax: sup?.firstname + " " + sup?.lastname
                };

                // Ensure newCollections is an array
                if (Array.isArray(this.newCollections)) {
                  this.newCollections.push(object);
                } else {
                  console.error('newCollections is not an array:', this.newCollections);
                }

                // Ensure suppliers remains an array
                this.suppliers = Array.isArray(this.suppliers) ? this.suppliers : [];
                this.suppliers = this.suppliers.filter(supplier => supplier.trip_id !== sup.trip_id);
                break;
              }
            }
          });
          this.checkBranding();
        } else {
          this.newCollections = [];
        }
      }
    },
    async getAllBrandings() {
      this.brandings = [];
      let self = this;
      await self.doPost({}, 'getAllBranding', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          let result = res.data.data;
          for(let i = 0; i < result.length; i++){
            self.brandings.push(result[i])
          }
        }
      });
    },

    checkBranding() {
      this.newCollections.forEach(trip => {
        this.brandings.forEach(branding => {
          if(trip?.brandingID == branding?.id) {
            trip.brandingName = branding.bezeichnung;
            trip.brandingLogo = branding.baseLogo
          }
        })
      })
    },

    async getAllCollections() {
      let self = this;
      self.brands = [];
      self.doPost({}, 'getAllCollections', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
          } else {
            let result = res.data.data;
             for(let i = 0; i < result.length; i++){
              self.brands.push(result[i]);
            }
          }
        }
      );
    },

    async editTripFromCollection(brand) {
      if (!Object.prototype.hasOwnProperty.call(brand, 'editTrip')) {
        this.$set(brand, 'editTrip', false);
      }
      brand.editTrip = !brand.editTrip;
    },

    async saveEditedTrip(brand){
      if(brand.bezeichnungTrip == '') {
        this.showSnackBar('editWarn')
      }else {
        brand.editTrip = false;
        this.updateTripDescription(brand);
      }

    },

    triggerDeleteTripInfo(brand) {
      this.deleteBrand = brand;
      let popUp = document.getElementById('popUp');
      popUp.classList.toggle('dNone');
    },

    async deleteTripFromCollection() {
      let popUp = document.getElementById('popUp');
      let id = this.deleteBrand.trip_id;
      let numArray = Array.isArray(this.collection) ? [...this.collection] : [];
      const index = numArray.findIndex(obj => obj.id === id);
      if (index !== -1) {
        numArray.splice(index, 1);
      }
      if (numArray.length <= 0) {
        numArray = "null";
      }
      this.collection = numArray;
      let myData = {
        collection: JSON.stringify(numArray),
        id: this.id
      };
      this.$emit('update:collection', numArray);
      let self = this;
      await this.doPost({ data: myData }, 'removeTripToCollection', async function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.remove = true;
          await self.getAllSuppliers();
          await self.getTrips();
        }
      });
      popUp.classList.add('dNone');
      await self.resetpdfs();
    },
    async getAllSuppliers() {
      let button = document.getElementById("addTripButton")
      button.setAttribute("disabled", true);
      let self = this;
      await this.doPost({user: self.options.user}, 'getTripsForCollection', async function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          await self.responseToTableData(res.data.data, self.cols).then(values => {
            self.suppliers = values;
          })
          if(self.suppliers.length > 0){
            let uebergabe = [];
            if (self?.options?.user?.brandings.length > 0) {
              self.suppliers.forEach(sup => {
                    if (self?.options?.user?.brandings.includes(sup.branding_id) && sup.branding_id != null) {
                        uebergabe.push(sup);
                    }
                });
            }
            self.suppliers = uebergabe;
          }
          await self.responseToTableData(res.data.noGroup, self.cols).then(values => {
            self.noGroupSuppliers = values;
          });

          if (self.noGroupSuppliers.length > 0 && self?.options?.user?.brandings?.length > 0) {
            let uebergabe = [];
            self.noGroupSuppliers.forEach(sup => {
              if (self.options.user.brandings.includes(sup.branding_id) && sup.branding_id != null) {
                uebergabe.push(sup);
              }
            });
            self.noGroupSuppliers = uebergabe;
          }
        }
        self.options.isUploading = false;
        self.isLoaded = true;
      });
    },

    checksaveButton(){
      let button = document.getElementById("saveButton");
      if(this.bezeichnung != "" && this.bezeichnung != null){
        button.removeAttribute("disabled");
      }else{
        button.setAttribute("disabled", true);
      }
    },

    checkButton(){
      if(this.form.supplier != "" && this.form.supplier != null && this.bezeichnungTrip != "" && this.bezeichnungTrip != null){
        let button = document.getElementById("addTripButton")
        button.removeAttribute("disabled");
      }
    },

    setSupplier(event) {
      const _supplier = this.suppliers.find(x => x.trip_id === event.trip_id);
      this.form.supplier = _supplier?.trip_id;
      this.inputTripId = '';
      this.inputTripId = _supplier?.trip_id;
      this.checkButton()
      this.setFocusToDesTrip();
    },

    getSupplierSelection(searchTerm) {
      if (searchTerm == "" || searchTerm == null) {
        let button = document.getElementById("addTripButton");
        button.setAttribute("disabled", true);
      }
      this.supplierList = new Promise(resolve => {
        window.setTimeout(() => {
          if (!searchTerm) {
            resolve(this.noGroupSuppliers);
          } else {
            const term = String(searchTerm).toLowerCase();
            resolve(this.noGroupSuppliers.filter(({ trip_id, firstname, lastname }) => {
              const paxInfo = firstname + " " + lastname
              const fullName = paxInfo ? paxInfo.toLowerCase() : '';
              return trip_id.toLowerCase().includes(term) || fullName.includes(term);
            }));
          }
        }, 500);
      });
    },

    async addTrip(){
      let self = this;
      let hasMatch;
      let matched;
      let collection = [];

      let updatedData = {
        tripid: this.form.supplier,
        id: this.id,
        bezeichnungTrip : this.bezeichnungTrip
      }

      /////HIER WEITER MACHEN
      this.brands.forEach(brand => {
        let colbrand;
        if (brand?.collection == null ||
            (typeof brand?.collection === 'string' && /.*null.*/i.test(brand.collection))) {
          brand.collection = [];
          colbrand = brand?.collection;
        } else {
          try {
            colbrand = JSON.parse(brand?.collection);
            if (!Array.isArray(colbrand)) colbrand = [];
          } catch (e) {
            console.warn("Invalid JSON in brand.collection:", brand?.collection);
            colbrand = [];
          }
        }
        colbrand.forEach(col => {
          collection.push(col.id)
        })
      })

      if(collection.some(c => c == updatedData.tripid)) {
        this.showSnackBar('tripSnackbar2')
        return
      }

      if (Array.isArray(this.suppliers)) {
        hasMatch = this.suppliers.some(sup => {
        matched = sup;
        return sup.trip_id === updatedData.tripid;
      })};
      if (!hasMatch) {
        this.showSnackBar('tripSnackbar');
        return;
      }
      const cleaned = this.collection?.toString().trim().replace(/^"+|"+$/g, "").toLowerCase();
      if (cleaned && cleaned !== "null"){
        let uebergabe;

        if (typeof this.collection === 'string') {
              try {
                uebergabe = JSON.parse(this.collection);
              } catch (e) {
                  console.error('The collection is not a valid JSON string:', e);
              }
        } else {
            uebergabe = this.collection;
          }

        let object = {
          id: updatedData.tripid,
          bezeichnung: this.bezeichnungTrip
        }
        this.collection = uebergabe
        uebergabe.push(object)
      }else{
          this.collection = [];

          let object = {
            id: updatedData.tripid,
            bezeichnung: this.bezeichnungTrip
          }

          this.collection.push(object)
        }
      updatedData.collection = JSON.stringify(this.collection);

      await this.doPost({ data: updatedData }, 'addTripToCollection', async function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.form.supplier = ""
                self.bezeichnungTrip = ""
                await self.getAllSuppliers()
                await self.getTrips()

        }
      });
      await self.resetpdfs();
    },

    async save() {
      let self = this;
      this.bezeichnung = this.bezeichnung.trim();
      let updateData = {
        bezeichnung: this.bezeichnung,
        id: this.id
      }

      if(this.brands.some(b => b.name === this.bezeichnung)) {
        this.showSnackBar('snackBar2');
        } else {
          await this.doPost({ data: updateData }, this.id == null ? 'newCollection' : 'updateCollection', async function (res) {
            if (res.data.status === 'error') {
              self.help.log(self.$t(res.msg), false, true);
              } else {
                self.isAutocompleteDisabled = false
                self.isAutocompleteDisabled2 = false
                if(self.id == null){
                  await self.doPost({data: self.options.user}, 'getAllCollections', async function (res) {
                    if (res.data.status === 'error') {
                      self.help.log(self.$t(res.msg), false, true);
                      } else {
                        let result = res.data.data;
                        for(let i = 0; i < result.length; i++){
                          if(updateData.bezeichnung = result[i].name){
                            self.id = result[i].id
                          }
                        }
                      }
                  });
                }
              }
            })
          this.showSnackBar('succsesSave');
          };
    },

    showSnackBar(value) {
      let snackBar = document.getElementById(`${value}`);
      snackBar.classList.remove('dNone');
      setTimeout(() => {
        snackBar.classList.add('dNone');
      }, 4000);
    },

    abort() {
      window.setTimeout(function(){location.reload();}, 1000)

    },
    close(){
      window.setTimeout(function(){location.reload();}, 100)
    },
    openDialog() {
      //do stuff
    },
    closeDialog() {
      this.options.showGlobalInfoForm = false;
    },
    refreshDialog() {
      let self = this;
      self.options.showGlobalInfoForm = false;
      self.$nextTick(() => {
        // Adding the component back in
        self.options.showGlobalInfoForm = true;
      });
    },

    setFocusToDesTrip() {
      let desTrip = document.getElementById('bezeichnungTrip');
      setTimeout(() => {
        desTrip.focus();
      }, 0);
    },

    async updateTripDescription(brand) {

      let updatedData = {
        id: this.id,
        bezeichnungTrip: brand?.bezeichnungTrip,
        tripid: brand?.trip_id,
      }

      let uebergabe;

        if (typeof this.collection === 'string') {
              try {
                uebergabe = JSON.parse(this.collection);
              } catch (e) {
                  console.error('The collection is not a valid JSON string:', e);
              }
          } else {
            uebergabe = this.collection;
          }

      if(uebergabe.length > 0){

        uebergabe.forEach(element =>{
          if(element.id == updatedData.tripid){
            element.bezeichnung = updatedData.bezeichnungTrip
          }
        })

        updatedData.collection = JSON.stringify(uebergabe)

        let self = this;

        await self.doPost({ data: updatedData }, 'addTripToCollection', async function (res) {
          if (res.data.status === 'error') {
            self.help.log(self.$t(res.msg), false, true);
            } else {

            }
          });
        await self.resetpdfs();
      }


      },

      async resetpdfs(){
      let data = {
			  tripId : "allall"
		}
      let self = this;
      await self.doPost({data: data}, 'setStatusPdf', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        self.pdfReset = false;
      }
    });
    },

    },


}
</script>
<style scoped lang="scss">

.headlineContainer {
  display: flex;
  justify-content: space-between;

  span {
    margin-left: -1rem;
    font-size: 2rem;
  }

  button {
    margin-right: 4rem;
  }
}

.groupMainContainer {
  background: white;
  padding: 20px;
  margin-left: 2.5rem;
  margin-right: 4rem;
}

.groupNameContainer {
  display: flex;
  margin-top: 3rem;
  margin-left: 1.5rem;
  width: calc(100% - 3rem);

  .groupName {
    display: flex;
    flex: 1;
    align-items: center;

    .inputContainer {
      padding-top: 20px;
      margin-right: 20px;
      width: 80%;
    }
  }
}

.groupTrip {
  display: flex;
  align-items: center;
  margin-top: 3rem;
  margin-left: 1.5rem;
  width: calc(100% - 3rem);

  .addTrip {
    display: flex;
    width: 100%;

    .addTripContainer {
      display: flex;
      flex: 1;
      align-items: center;
      margin-right: 20px;
    }
  }

  .addTripDescription {
    display: flex;
    width: 100%;

    .addTripDescriptionContainer {
      display: flex;
      flex: 1;
      align-items: center;
      margin-right: 20px;

      div {
        padding-top: 20px;
      }
    }
  }
}

.buttonContainer {
  display: flex;
  align-items: center;
}

.showTrips {
  margin-top: 3rem;
  margin-left: 1.5rem;

  .tripBranding {
    margin-right: 3rem;
    width: 7rem;
  }

  .tripID {
    min-width: 10rem !important;
    max-width: 10rem !important;
    width: 10rem !important;
    margin-right: 3rem;
    display: inline-block;
  }

  .tripBuyer {
    // min-width: 25rem !important;
    // max-width: 25rem !important;
    // width: 25rem !important;
    width: 18rem;
    margin-right: 3rem;
    display: inline-block;
  }

  .tripDescription {
    min-width: 30rem !important;
    max-width: 30rem !important;
    width: 30rem !important;
    margin-right: 3rem;
    display: inline-block;
    button {
      // width: 40px;
      width: auto;
      min-width: unset;

      i {
        margin: 0 !important;
      }
    }
  }
}

.modul{
  width: 100%;
  height: 5rem;
  background-color: white;
  border-radius: 1rem;
  display: flex;
  padding-left: 1rem;
  padding-right: 1rem;
  // padding-bottom: 1rem; out by Tom
  padding-top: 0;
  justify-content: space-between;
  margin-bottom: 1rem !important;
  align-items: center; //Added by Tom
}

.modul:hover{
  background-color: rgb(240, 240, 240);
}

.modul p {
  font-size: 18px;
  font-weight: 100;
  align-self: center;
  display: flex; // Added By Tom
  align-items: center; //Added by Tom
  span {
    display: flex !important;
    align-items: center !important;
  }
}

.showTripIcon {
  button {
    width: auto;
    min-width: 68px;

    i {
      margin: 0 !important;
    }
  }
} 

.ProseMirror {        
  min-height: 13rem;
  min-width: 16.5rem;
  max-width: 16.5rem;
  overflow-x: scroll;
  overflow-y: hidden;
  max-height:  13rem;
}

.ProseMirror img{
  height: 25% !important;
  width: 25% !important;
}

::-webkit-scrollbar {
    display: none;
}

#emailvorlage{
  margin-left: 3rem;
  margin-right: 3rem;
  margin-top: 2rem;
}
.editCat{
  z-index: 111111;
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: transparent;
}
.bgEdit{
  background-color: rgb(94, 94, 94);
  padding-top: 1rem;
  padding-bottom: 1rem;
  height: 100%;
  width: 100%;
  opacity: 0.5;
}

#divEmail{
  background: white;
  width: 107%;
  padding: 3rem;
  margin-left: -3rem;
  padding-bottom: 5rem;
}

.areaa{
  padding: 10px 10px !important;
  background-color: #F5F6FA !important;
  line-height: 20px;
  height: 52px;
  font-size: 14px !important;
  color: #202224 !important;
  border: 0.6px solid #D5D5D5;
  -webkit-text-fill-color: #A6A6A6 !important;
  border-radius: 4px;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  max-width: 100% !important;
  min-width: 100% !important;
  font-family: inherit;
}

.contentEdit{
  margin-top: -14rem;
  padding: 3rem;
  background-color: white;
  width: 90%;
  height: 80%;
  left: 5%;
}
.formTD {
  background-color: rgb(249, 249, 249);
  margin-bottom: 5px;
}

.choose-file::file-selector-button {
  font-weight: bold;
  color: #202224;
  font-family: "Nunito", sans-serif !important;
  font-size: 14px !important;
  background-color: #E1E8F3;
  padding: 10px 24px;
  outline: none;
  border: none;
  border-radius: 10px;
  width: 155px;
  height: 38px;
  display: inline-block;
  margin-top: 8px;
}

.choose-file::file-selector-button:hover{
 cursor:pointer;
 background-color: #c9cbce;
}

#sigfield{
  z-index: 111111;
}

#logo{
  width: 100% !important;
}

#logoback{
  width: 100% !important;
}

.secondary,
.button-save {
  height: 38px !important;
}

.imglogoback{
  max-width: 100% !important;
  max-height: 100% !important;
}

.ProseMirror table{
  color: red !important;
}

.uploadedLogo{
  display: flex;
  justify-content: center;
  align-items: center;
  background: #E1E8F3;
  height: 260px;
  width: 284px;
  margin-top: 10px;
  margin-bottom: 10px;
}


#hello .ProseMirror{
  height: 10rem !important;
  width: 100% !important
}

#helloeng .ProseMirror{
  height: 10rem !important;
  width: 100% !important
}

#street,#plz,#company,#tel, #bezeichnungTrip, #autocompl, #fax,#city,#email,#impressum,#datenschutz,#color,#signature, #hello, #helloeng, #reply, #replyzugang, #agbs, #vermittelt, #bezeichnung, #reiseversicherung, #infoDocs, #mitarbeiterbezeichnung{
  -webkit-text-fill-color: black !important;
}
.wide-autocomplete-item {
  width: 1000px !important; /* Oder eine spezifische Breite wie 300px */
  display: flex;
  background-color: red !important;
  justify-content: space-between;
  padding: 10px;
  box-sizing: border-box;
}

.md-menu-content{
  width: 1000px !important;
  text-align: left !important;
  max-width: 1000px !important;
}

.autoidth{
  width: 1000px !important;
  text-align: left !important;
  max-width: 1000px !important;
}

.md-list-item-content{
  justify-content: unset !important;
}

.showInfo{
  margin-right: 2rem !important;
}

.mWidth7 {
  min-width: 7rem;
}

.mWidth10 {
  min-width: 10rem;
}

.editTripDesInput {
  border: none;
  height: 30px;
  width: unset;
  border-radius: 10px;
  padding: 0 10px;
  font-size: 14px;
  font-weight: 100;
  font-family: inherit;
}

#snackBar {
  width: auto;
  background-color: green;
  padding: 0px 10px;
  border-radius: 1rem;
  color: white;
  font-weight: 600;
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 0;
  left: 0;
}

#succsesSave {
  position: absolute;
  color: green;
  // top: 330px;
  // right: 120px;
  top: 75px;
  left: 10px;
  font-style: italic;
}

#snackBar2,
#tripSnackbar,
#tripSnackbar2 {
  position: absolute;
  top: 75px;
  left: 10px;
  color: red;
  font-style: italic;
}

#editWarn {
  position: absolute;
  bottom: 0px;
  right: 500px;
  color: red;
  font-style: italic;
}

.dNone {
  display: none !important;
}

.popUp {
  // background-color: rgba(0,0,0,0.75);
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 9;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .popUpContainer {
   
    .pop {
      position: unset !important;
      top: 35%;
      padding: 3rem;
      background-color: white;
      width: 100%;
      height: 13rem;
      left: 5%;
    }

    .buttonContainer {
      float: right;
      margin-top: 25px;
    }
  }
}
</style>